import { Add, Folder, Icon, IconSize, Menu, MenuItem, MoreVertical } from '@soteria/design-system-ve';

import * as styles from './Guide.css';

interface GroupMenuProps {
  groupId: string;
  groupName: string;
  isOpen: boolean;
  canAddCommunity: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onViewGroupDetails: (groupId: string) => void;
  onAddCommunity: (groupId: string) => void;
}

/**
 * GroupMenu component
 * Provides action menu for community groups with proper accessibility
 */
export function GroupMenu({ groupId, groupName, isOpen, canAddCommunity, onOpenChange, onViewGroupDetails, onAddCommunity }: GroupMenuProps) {
  const triggerId = `group-menu-trigger-${groupId}`;

  const handleViewGroupDetails = () => {
    onViewGroupDetails(groupId);
    onOpenChange(false);
  };

  const handleAddCommunity = () => {
    onAddCommunity(groupId);
    onOpenChange(false);
  };

  return (
    <>
      <button
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-label={`More actions for ${groupName}`}
        className={styles.groupMenuButton}
        id={triggerId}
        type="button"
        onClick={e => {
          e.stopPropagation();
          onOpenChange(true);
        }}
      >
        <Icon icon={MoreVertical} iconSize={IconSize.XSmall} />
      </button>

      {isOpen && (
        <Menu isOpen showCloseButton={false} triggerId={triggerId} onOpenChange={onOpenChange}>
          <MenuItem icon={<Icon icon={Folder} iconSize={IconSize.XSmall} />} label="View Group Details" onClick={handleViewGroupDetails} />
          {canAddCommunity && <MenuItem icon={<Icon icon={Add} iconSize={IconSize.XSmall} />} label="Add Community" onClick={handleAddCommunity} />}
        </Menu>
      )}
    </>
  );
}
